<template>
    <div class="tutorial-navigation">
        <!-- Navigation Controls -->
        <div class="pagination">
            <button class="fab m" @click="movePageAmount(-1)" :disabled="pageIndex <= 0">
                <img style="transform: rotate(180deg)" :src="getMedia('icons/chevron-right.svg')" alt="">
            </button>

            <div class="dots">
                <div v-for="(page, index) in pageCount" :key="index" :class="['dot', { 'active': index === pageIndex }]" @click="moveToPage(index)"></div>
            </div>

            <button class="fab m" @click="movePageAmount(1)" :disabled="pageIndex >= (pageCount - 1)" >
                <img :src="getMedia('icons/chevron-right.svg')" alt="">
            </button>
        </div>

        <!-- Complete Button -->
        <button title="Skip Tutorial" :class="{ 'tertiary': pageIndex < (pageCount - 1), 'primary': pageIndex >= (pageCount - 1) }" @click="setTutorialVisible(false)">
            {{ t(pageIndex < (pageCount - 1) ? "Skip" : "Complete" ) }}
        </button>
    </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { getMedia } from '@/util';

const props = defineProps({
    pageIndex: { type: Number, required: true },
    pageCount: { type: Number, required: true },
    setActivePage: { type: Function, required: true },
    setTutorialVisible: { type: Function, required: true }
});

const { t } = useI18n();

function movePageAmount(amount: number) {
    let newIndex = props.pageIndex + amount;

    if (newIndex < 0) 
        newIndex = 0;

    if (newIndex >= props.pageCount) 
        newIndex = props.pageCount - 1;

    props.setActivePage(newIndex);
}

function moveToPage(index: number) {
    if (index < 0 || index >= props.pageCount) 
        return;
    
    props.setActivePage(index);
}
</script>

<style lang="scss" scoped>
.tutorial-navigation{
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;

    padding-bottom: 1rem;
}

.pagination {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    .dots {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        margin: 0 1rem;
        
        .dot {
            height: 0.5rem;
            width: 0.5rem;
            border-radius: 50%;
            margin: 0 0.2rem;
            border: solid 3px var(--color-lightblue);
        
            cursor: pointer;
            transition: .3s ease;
        
            &.active {
                background-color: var(--color-lightblue);
            }
        }
    }
}


</style>